__turbopack_context__.v({
  "arguments": "_9VH1hG_arguments",
  "canvas": "_9VH1hG_canvas",
  "command": "_9VH1hG_command",
  "completed": "_9VH1hG_completed",
  "graph": "_9VH1hG_graph",
  "inputFlag": "_9VH1hG_inputFlag",
  "response": "_9VH1hG_response",
  "response-first": "_9VH1hG_response-first",
  "response-second": "_9VH1hG_response-second",
  "response-third": "_9VH1hG_response-third",
  "runIcon": "_9VH1hG_runIcon",
  "running": "_9VH1hG_running",
  "scene": "_9VH1hG_scene",
  "started": "_9VH1hG_started",
  "terminal": "_9VH1hG_terminal",
  "titlebar": "_9VH1hG_titlebar",
  "transcript": "_9VH1hG_transcript",
  "windowDots": "_9VH1hG_windowDots",
});
